import { render, staticRenderFns } from "./SingleNote.vue?vue&type=template&id=35cd93ed&"
import script from "./SingleNote.vue?vue&type=script&lang=js&"
export * from "./SingleNote.vue?vue&type=script&lang=js&"
import style0 from "./SingleNote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports